module.exports = __webpack_public_path__ + "img/kr-product-title-img-2.c99f71b.png";